import { FirebaseError } from "firebase/app";
import { reportError } from "./sentry";

/**
 * Normalize any thrown value into a short, user-facing message.
 * Callable HttpsErrors carry a human-readable message from the server
 * (e.g. "You're out of messages for this connection.") — surface those
 * verbatim; everything else gets a generic fallback and is reported.
 */
export function friendly(e: unknown, fallback = "Something went wrong. Please try again."): string {
  if (e instanceof FirebaseError) {
    // functions/* errors carry curated server messages — show them.
    if (e.code.startsWith("functions/") && e.message && !/internal/i.test(e.code)) {
      return e.message;
    }
    if (e.code === "functions/internal" || e.code === "internal") {
      reportError(e);
      return "Server hiccup — please try again.";
    }
    if (e.code.includes("unavailable") || e.code.includes("network")) {
      return "You're offline. Check your connection and try again.";
    }
    return e.message || fallback;
  }
  if (e instanceof Error) {
    reportError(e);
    return e.message || fallback;
  }
  reportError(new Error(String(e)));
  return fallback;
}

/** Machine-readable reason attached by the server (HttpsError details.reason). */
export function errorReason(e: unknown): string | null {
  const details = (e as { customData?: { serverResponse?: unknown }; details?: unknown })?.details as
    | { reason?: string }
    | undefined;
  return details?.reason ?? null;
}
